export enum FORM_CASE_ENUM {
  CONTACT_FORM = 1,
  CODE_FORM = 2,
  HAS_A_CODE = 3,
  CPF_ONLY = 4,
  TENANT_SELECTION = 5,
  PASSWORD_FORM = 6,
}
